import { useNavigation } from 'expo-router';
import { CommonActions } from 'expo-router/react-navigation';
import { useEffect } from 'react';

export default function useResetHistory() {
  const navigation = useNavigation();

  useEffect(() => {
    const navigationState = navigation.getState()?.routes;

    if (!navigationState) return;

    const lastRoute = navigationState[navigationState.length - 1];

    navigation.dispatch(
      CommonActions.reset({
        routes: [
          {
            key: lastRoute.key,
            name: lastRoute.name,
            params: lastRoute.params,
          },
        ],
      }),
    );
  }, [navigation]);
}
